// extracted by mini-css-extract-plugin
export var arrowsContainer = "carousel-module--arrowsContainer--ffa32";
export var card = "carousel-module--card--3452d";
export var cardContent = "carousel-module--cardContent--4d70a";
export var cardsContainer = "carousel-module--cardsContainer--30678";
export var filter = "carousel-module--filter--1eb6e";
export var image = "carousel-module--image--821d1";
export var title = "carousel-module--title--da85f";